module.exports = __webpack_public_path__ + "static/media/liquids.0391e795.svg";